import { Button } from "@/components/Button/Button";
import { Color } from "@/typed/Common";
import { SxProps, Theme } from "@mui/material";
import { ReactElement, ReactNode } from "react";

interface PillButtonProps {
  startIcon?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  children?: ReactNode;
  sx?: SxProps<Theme>;
  variant?: "text" | "outlined" | "contained";
  color?: Color;
}

export const PillButton = ({ startIcon, onClick, disabled, children, sx, ...props }: PillButtonProps): ReactElement => {
  return (
    <Button
      variant="contained"
      disabled={disabled}
      sx={{
        borderRadius: "100px",
        height: "32px",
        ...sx
      }}
      onClick={onClick}
      startIcon={startIcon}
      {...props}
    >
      {children}
    </Button>
  );
};
